import React from "react";

function Colors_NCS() {
  return (
    <div>
      <h1>Colors_NCS Component</h1>
      <p>This is the Colors NCS tutorial page content.</p>
    </div>
  );
}

export default Colors_NCS;
